const tr = {
  meta: {
    title: "OnHuman.tech — insan işinin üzerinde koştuğu yazılımı geliştiriyoruz",
  },
  brand: {
    name: "OnHuman Technology",
    tagline: "İnsan odaklı yazılımın geleceğini inşa ediyoruz",
    hrLinkLabel: "OnHuman HR",
  },
  nav: {
    capabilities: "Yetenekler",
    process: "Süreç",
    domains: "Alanlar",
    contact: "Bize ulaşın",
  },
  hero: {
    title: ["İnsan işi için", "mühendislik."],
    cta: "Bir proje başlat",
  },
  capabilities: {
    title: ["Dört disiplin,", "tek stüdyo."],
    lede:
      "Bağımsız modüller, uçtan uca ürünler veya özel entegrasyonlar; probleme en uygun platformda. Ne geliştirdiğimizi görmek için bir disiplin seçin.",
    listLabel: "Disiplinler",
    builtWith: "Teknolojiler",
    youGet: "Teslim edilen",
    items: [
      {
        key: "mobile",
        word: "Mobil",
        title: "Mobil uygulamalar",
        desc: "iOS ve Android için native ve React Native uygulamalar. Çevrim dışı çalışır, güvenli depolama ve yayına hazır bir derleme hattı.",
        stack: ["iOS", "Android", "React Native"],
        deliverable: "Mağazaya hazır bir uygulama ve kendi yönetebileceğiniz bir yayın hattı.",
      },
      {
        key: "desktop",
        word: "Masaüstü",
        title: "Masaüstü yazılımı",
        desc: "Windows ve çapraz platform masaüstü yazılımları. Electron, .NET ve gerektiğinde native Win32.",
        stack: ["Windows", "macOS", "Electron", ".NET"],
        deliverable: "Windows ve macOS için imzalı, otomatik güncellenen bir kurulum paketi.",
      },
      {
        key: "web",
        word: "Web",
        title: "Web uygulamaları",
        desc: "Modern web uygulamaları, kurum içi araçlar ve paneller. Tip güvenli, erişilebilir, gerçek iş akışına göre tasarlanmış.",
        stack: ["React", "Next.js", "Node", "PostgreSQL"],
        deliverable: "Tasarım sistemi, testler ve sürekli teslimatla yayına alınmış bir uygulama.",
      },
      {
        key: "ai",
        word: "Yapay zeka",
        title: "Yapay zeka ve otomasyon",
        desc: "LLM entegrasyonları, belge zekası ve iş akışı otomasyonu. Haftada kazanılan saatle ölçülen pratik yapay zeka.",
        stack: ["OpenAI", "Anthropic", "Python"],
        deliverable: "Haftalık bir angaryayı ortadan kaldıran, sonucu ölçülebilen bir otomasyon.",
      },
    ],
  },
  process: {
    title: ["Belirsizlikten", "yayınlanan ürüne."],
    lede: "Aralarında net bir devir teslim olan dört aşama. İşin nerede olduğunu her zaman bilirsiniz.",
    steps: [
      {
        n: "01",
        title: "Keşif",
        desc: "Tek satır kod yazılmadan önce problem alanını, paydaşları ve kısıtları haritalarız.",
      },
      {
        n: "02",
        title: "Tasarım",
        desc: "Mimari, veri modelleri ve kullanıcı akışları; paralelde gözden geçirilir ve riski azaltılır.",
      },
      {
        n: "03",
        title: "Geliştirme",
        desc: "Kısa iterasyonlar, sürekli teslim ve ilk günden ölçümleme.",
      },
      {
        n: "04",
        title: "İşletme",
        desc: "Gözlemlenebilirlik, dokümantasyon ve eğitimle işletebileceğiniz bir sistem teslim ederiz.",
      },
    ],
  },
  domains: {
    title: ["İK'da doğdu.", "Her yerde işe yarar."],
    lede:
      "OnHuman Technology, OnHuman HR'ın kendi operasyonlarından doğdu. Bugün İK, işe alım ve iş yerinde insana dokunan ilişkili ekipler için geliştiriyoruz.",
    items: [
      { title: "İnsan kaynakları", desc: "Temel İK operasyonları, iş gücü planlama ve insan stratejisi." },
      { title: "İşe alım", desc: "Yetenek kazanımı, aday hatları ve işe alım akışları." },
      { title: "İş gücü analitiği", desc: "Kadro, elde tutma ve performans için veriye dayalı içgörü." },
      { title: "Öğrenme ve gelişim", desc: "Eğitim programları, beceri takibi ve kariyer yolları." },
      { title: "Uyumluluk", desc: "Mevzuata uyum, politika yönetimi ve denetime hazırlık." },
      { title: "Kurum içi araçlar", desc: "Operasyon, raporlama ve ekipler arası akışlar için özel araçlar." },
    ],
  },
  cta: {
    title: ["Bir fikriniz mi var?", "Birlikte yapalım."],
    lede: "Ne geliştirmek istediğinizi anlatın. Bir plan, uygun teknoloji yığını ve gerçekçi bir takvimle dönelim.",
    button: "E-posta gönderin",
    email: "contact@onhumanresources.com",
    note: "İstanbul merkezli, her yerde çalışıyoruz.",
  },
  footer: {
    blurb: "Kurumların ihtiyaçlarına özel mobil, masaüstü, web ve yapay zeka çözümleri geliştiren bir yazılım stüdyosu.",
    emailLabel: "E-posta",
    rights: "Tüm hakları saklıdır.",
    location: "İstanbul, Türkiye",
  },
};

export default tr;
